import { z } from 'zod';

import { BaseWidgetSchema } from './BaseWidgetSchema';
import { WidgetType } from '../../utils/widgetsUtils';

export const EmbedWidgetStaticSchema = BaseWidgetSchema(WidgetType.Embed).extend({
  src: z.string(),
  title: z.string()
});

export type EmbedWidgetStaticSchemaType = z.infer<typeof EmbedWidgetStaticSchema>;
